import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Permission'],
});

export const permissionApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllPermission: builder.query({
      query: () => `function_permissions/`,
      keepUnusedDataFor: 0,
      providesTags: ['Permission'],
    }),

    findPermissionById: builder.query({
      query: (id) =>
       `function_permissions/${id}/`,
       keepUnusedDataFor: 0,
       providesTags: ['Permission'],
    }),

    createFunctionPermission: builder.mutation({
      query: (payload) => ({
        url: `function_permissions/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Permission'],
    }),
    updateFunctionPermission: builder.mutation({
      query: (payload) => ({
        url: `function_permissions/${payload.id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['Permission'],
    }),
    
    deleteFunctionPermission: builder.mutation({
      query: (payload) => ({
        url: `function_permissions/${payload.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Permission'],
    }),


  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllPermissionQuery,
  useFindPermissionByIdQuery,
  useCreateFunctionPermissionMutation,
  useUpdateFunctionPermissionMutation,
  useDeleteFunctionPermissionMutation,
  
} = permissionApi;
